import { createActions } from 'redux-actions';
import keyMirror from 'keymirror';

export const constants = keyMirror({
    SET_ASSET_TAB_FILTERS: null,
    RESET_ASSET_TAB_FILTERS: null,
    
    SET_DIVISION_TAB_FILTERS: null,
    RESET_DIVISION_TAB_FILTERS: null,

    SET_TAGS_TAB_FILTERS: null,
    RESET_TAGS_TAB_FILTERS: null,

    SET_DRIVER_TAB_FILTERS: null,
    RESET_DRIVER_TAB_FILTERS: null,

    SET_USER_TAB_FILTERS: null,
    RESET_USER_TAB_FILTERS: null,
});

export const {
    setAssetTabFilters,
    resetAssetTabFilters,
} = createActions(
    constants.SET_ASSET_TAB_FILTERS,
    constants.RESET_ASSET_TAB_FILTERS,
);

export const {
    setDivisionTabFilters,
    resetDivisionTabFilters,
} = createActions(
    constants.SET_DIVISION_TAB_FILTERS,
    constants.RESET_DIVISION_TAB_FILTERS,
);

export const {
    setTagsTabFilters,
    resetTagsTabFilters,
} = createActions(
    constants.SET_TAGS_TAB_FILTERS,
    constants.RESET_TAGS_TAB_FILTERS,
);

export const {
    setDriverTabFilters,
    resetDriverTabFilters,
} = createActions(
    constants.SET_DRIVER_TAB_FILTERS,
    constants.RESET_DRIVER_TAB_FILTERS,
);

export const {
    setUserTabFilters,
    resetUserTabFilters,
} = createActions(
    constants.SET_USER_TAB_FILTERS,
    constants.RESET_USER_TAB_FILTERS,
);